<template>
    <div class="md:grid md:grid-cols-12 md:gap-6">
        <div class="sm:col-span-12">
            <div class="mt-1">
                <FormLabel :value="$t('messages.randomize_options')" for="randomize_options">
                    ({{ $t('messages.order_does_not_matter') }})
                </FormLabel>
                <input
                    name="selected"
                    v-model="form.randomize_options"
                    id="randomize_options"
                    type="checkbox"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                />
            </div>
        </div>

        <template v-if="form.choices">
            <div
                class="sm:col-span-12"
                v-for="(option, index) in form.choices"
                :key="`${index}_${form.correct_answer_index}`"
            >
                <div class="mt-1">
                    <FormLabel :value="$t('messages.option_X', { x: index + 1 })" :for="`option_${index}`">
                        <CorrectIncorrectIcon :is-correct="form.correct_answer_index === index" />
                        <div class="mt-1 inline-block" v-show="form.randomize_options === false">
                            <label>
                                <input
                                    name="is_correct"
                                    type="radio"
                                    :id="`option_is_correct_${index}`"
                                    :value="index"
                                    v-model.number="form.correct_answer_index"
                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                />
                                {{ $t('messages.is_correct') }}
                            </label>
                        </div>
                    </FormLabel>
                    <div class="flex justify-between items-center">
                        <FormInput
                            required
                            :id="`option_${index}`"
                            v-model="option.text"
                            :name="`option_${index}`"
                            type="text"
                            max="191"
                            class="mt-1 w-full"
                        />
                        <button
                            type="button"
                            @click="deleteOption(form.choices, index)"
                            v-if="form.correct_answer_index !== index"
                            v-show="form.choices.length > 2"
                            class="inline-flex items-center px-1.5 py-1.5 border border-transparent text-xs font-medium rounded text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            <svg viewBox="0 0 20 20" fill="currentColor" class="trash w-4 h-4">
                                <path
                                    fill-rule="evenodd"
                                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </button>
                    </div>
                    <FormError :value="errors[`options.choices.${index}.text`]" class="mt-2" />
                </div>
            </div>

            <div v-show="form.choices.length < 15">
                <PlusButton @click="addOption()" />
            </div>
        </template>
    </div>
</template>

<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';

export default {
    name: 'QuestionMultipleChoiceOptions',
    components: {
        FormLabel,
        FormInput,
        FormError,
        PlusButton,
        CorrectIncorrectIcon,
    },
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            form: this.modelValue,
        };
    },
    watch: {
        form(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    methods: {
        deleteOption(choices, index) {
            choices.splice(index, 1);
            if (index < this.form.correct_answer_index) {
                this.form.correct_answer_index--;
            }
        },
        addOption() {
            this.form.choices.push({
                text: '',
            });
        },
    },
    mounted() {
        let defaultOptions = {
            correct_answer_index: 0,
            randomize_options: false,
            choices: [{ text: '' }, { text: '' }, { text: '' }, { text: '' }],
        };
        if (!this.form.hasOwnProperty('choices')) {
            Object.entries(defaultOptions).forEach((entry) => (this.form[entry[0]] = entry[1]));
        }
    },
};
</script>
